<div class="embedded-dashboard">
  <div #canvas class="embedded-dashboard__canvas"></div>

  <div class="embedded-dashboard__state" *ngIf="isLoading" role="status" aria-live="polite">
    <gains-spinner tip="Loading dashboard…"></gains-spinner>
  </div>

  <div class="embedded-dashboard__state" *ngIf="hasFailed" role="alert">
    <svg-icon src="assets/icons/triangle-with-exclamation-mark.svg" class="embedded-dashboard__state-icon" aria-hidden="true"></svg-icon>
    <p class="embedded-dashboard__state-message">{{ loadError }}</p>
    <button class="embedded-dashboard__retry" nz-button nzType="default" nzShape="round" (click)="retry()">
      <svg-icon src="assets/icons/arrow-rotate-anticlockwise.svg" class="embedded-dashboard__retry-icon" aria-hidden="true"></svg-icon>
      Try again
    </button>
  </div>
</div>
